var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLargeReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 135,
    viewBox: "0 0 134 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 20C109 19.4477 108.552 19 108 19H20C19.4477 19 19 19.4477 19 20V122C19 122.552 19.4477 123 20 123H108C108.552 123 109 122.552 109 122V20Z",
    fill: "url(#paint0_linear_3688_14685)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 17.2632C104 16.7109 103.552 16.2632 103 16.2632H17C16.4477 16.2632 16 16.7109 16 17.2632V116.263C16 116.815 16.4477 117.263 17 117.263H103C103.552 117.263 104 116.815 104 116.263V17.2632Z",
    fill: "url(#paint1_linear_3688_14685)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 34.7632H103.5V34.2632V19.2632C103.5 17.8825 102.381 16.7632 101 16.7632H19C17.6193 16.7632 16.5 17.8825 16.5 19.2632V34.2632V34.7632H17H103Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 35.2632H104V34.2632V19.2632C104 17.6063 102.657 16.2632 101 16.2632H19C17.3431 16.2632 16 17.6063 16 19.2632V34.2632V35.2632H17H103Z",
    fill: "url(#paint2_linear_3688_14685)",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45.2632H58",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55.2632H58",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65.2632H50",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75.2632H70",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 85.2632H70",
    stroke: "white",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95.2632H50",
    stroke: "white",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105.263H50",
    stroke: "white",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90 95.2632H95",
    stroke: "#0E5CF4",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75.2632H95",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55.2632H95",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45.2632H95",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105.263H95",
    stroke: "#0E5CF4",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85.2632H95",
    stroke: "#0E5CF4",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90 65.2632H95",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 79,
    width: 36.4846,
    height: 46.7368,
    fill: "url(#paint3_linear_3688_14685)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7961,
    y: 85.5921,
    width: 27.9605,
    height: 8.38815,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7961,
    y: 99.5724,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2522,
    y: 99.5724,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7083,
    y: 99.5724,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 107.164,
    y: 99.5724,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7961,
    y: 107.029,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2522,
    y: 107.029,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7083,
    y: 107.029,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7961,
    y: 114.485,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2522,
    y: 114.485,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7083,
    y: 114.485,
    width: 5.5921,
    height: 5.5921,
    fill: "#D3D8E4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 107.164,
    y: 107.029,
    width: 5.5921,
    height: 13.0482,
    fill: "#D3D8E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3688_14685",
    x1: 64,
    y1: -50.3488,
    x2: 64,
    y2: 168.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3688_14685",
    x1: 60,
    y1: -51.0165,
    x2: 60,
    y2: 161.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3688_14685",
    x1: -97.0835,
    y1: 11.6933,
    x2: -95.322,
    y2: 85.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3688_14685",
    x1: 99.2423,
    y1: 49.1453,
    x2: 99.2423,
    y2: 145.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE2EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLargeReport);
export default __webpack_public_path__ + "static/media/ic-large-report.2825d5ebb4f3d29e624ca8925f1410e7.svg";
export { ForwardRef as ReactComponent };